import React, { useState } from 'react'
import Icon from '@ant-design/icons'
import DataServices from '../../../Services/DataServices'
import IntlMessages from '../../../util/IntlMessages'
import {
  Table,
  Layout,
  Card,
  Col,
  Row,
  Button,
  Collapse,
  Space,
  Form,
  Input,
  Skeleton,
  Tabs,
  Tooltip,
  Select,
  Spin,
  Badge,
  message,
  Avatar,
  Modal,
  Divider
} from 'antd'
import { useHistory, useRouteMatch } from 'react-router'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { useDispatch, useStore, useSelector } from 'react-redux'
import ds from '../../../Services/DataServices'
import { EyeOutlined, CheckOutlined, ShoppingOutlined } from '@ant-design/icons'

const FulfillmentStatus = [
  { id: 0, value: 'All' },
  {
    id: 1,
    value: 'New'
  },
  {
    id: 2,
    value: 'In Progress'
  },
  {
    id: 3,
    value: 'Packed'
  }
]

const FulfillmentTypes = [
  { id: 0, value: 'All' },
  {
    id: 4,
    value: 'Delivery'
  },
  {
    id: 5,
    value: 'Pickup'
  }
]

const FulfillmentList = props => {
  const Panel = Collapse.Panel
  const history = useHistory()
  const { TabPane } = Tabs
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const store = useStore()
  const confirm = Modal.confirm

  const [getIsLoading, setIsLoading] = useState(true)
  const [getCurrentTab, setCurrentTab] = useState('1')
  const [key, setKey] = useState('')
  const [rowKey, setRowKey] = useState('')
  const [getTabLoader, setTabLoader] = useState(false)
  const [getDetailLoading, setDetailLoading] = useState(false)
  const [getIsPackOrder, setIsPackOrder] = useState(false)
  const [visible, setVisible] = useState(false)
  const [getDetailData, setDetailData] = useState({})
  const [getTabData, setTabData] = useState([])
  // const [getTabAllData, setTabAllData] = useState([]);
  const [getFulfillStatus, setFulfillStatus] = useState([])
  const [getFulfillTypes, setFulfillTypes] = useState([])
  const [outletData, setOutletData] = useState([])
  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    OutletID: 0,
    StatusID: 0,
    TypeID: 0,
    showSizeChanger: true,
    IsPackOrder: false
  })

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      setFulfillStatus(FulfillmentStatus)
      setFulfillTypes(FulfillmentTypes)
      getListingService(getPagination)
      getOutletsService()
    }

    return () => (mounted = false)
  }, [])

  async function getListingService (body) {
    const geListin = ds.getFulfillmentList(body)
    await geListin
      .then(res => {
        setIsLoading(false)
        if (res && res.length > 0) {
          let data = res.map(e => {
            return {
              key: e.salesOrderID,
              salesOrderID: e.salesOrderID.substring(
                0,
                e.salesOrderID.indexOf('&')
              ),
              outletName: e.outletName,
              status: e.status,
              type: e.type,
              customerGroupName: e.customerGroupName,
              firstName: e.firstName,
              lastName: e.lastName,
              customerEmail: e.customerEmail,
              customerCode: e.customerCode,
              receiptCode: e.receiptCode
            }
          })
          let paginationobj = {
            CurrentPageNo: res && res.length > 0 ? res[0].currentPageNo : 1,
            PageSize: res && res.length > 0 ? res[0].pageSize : 10,
            total: res && res.length > 0 ? res[0].totalRecords : 0,
            showSizeChanger: true,
            OutletID: form.getFieldValue('SearchOutlet')
              ? form.getFieldValue('SearchOutlet')
              : 0,
            StatusID: form.getFieldValue('SearchStatus')
              ? form.getFieldValue('SearchStatus')
              : 0,
            TypeID: form.getFieldValue('SearchType')
              ? form.getFieldValue('SearchType')
              : 0,
            IsPackOrder: getIsPackOrder
          }
          setPagination(paginationobj)
          setTabData(data)
        } else {
          setTabData([])
        }
      })
      .catch(e => {
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      }) //console.log("CatchAddEditBook", e));
  }

  async function getOutletsService () {
    const getOutlets = ds.getStoreOutlets()
    await getOutlets
      .then(response => {
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data && response.data.data.length > 0) {
              let data = response.data.data
              let all = {
                sOutletId: '0&&_ASD56_UIO78_PQW88',
                outletName: 'All'
              }
              data.unshift(all)
              let outletssData = data.map(e => {
                return {
                  id: parseInt(
                    e.sOutletId.substring(0, e.sOutletId.indexOf('&'))
                  ),
                  outlet: e.outletName
                }
              })
              setOutletData(outletssData)
            }
          }
        }
      })
      .catch(e => {
        // setIsLoading(false);
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut("store.getState()"));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function getDetailService (body) {
    const geListin = ds.getFulfillmentDetailService(body)
    await geListin
      .then(res => {
        setDetailLoading(false)
        if (res) {
          setDetailData(res)
        }
      })
      .catch(e => {
        setDetailLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      }) //console.log("CatchAddEditBook", e));
  }

  async function postFulfillment (body) {
    const req = ds.postFulfillmentService(body)
    await req
      .then(res => {
        if (res) {
          message.success('Sale Updated')
          var body = getPagination
          body.OutletID = form.getFieldValue('SearchOutlet')
            ? form.getFieldValue('SearchOutlet')
            : 0
          body.StatusID = form.getFieldValue('SearchStatus')
            ? form.getFieldValue('SearchStatus')
            : 0
          body.TypeID = form.getFieldValue('SearchType')
            ? form.getFieldValue('SearchType')
            : 0
          body.IsPackOrder = getIsPackOrder
          getListingService(body)
        } else {
          setIsLoading(false)
          message.error('Something went wrong...')
        }
      })
      .catch(e => {
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      }) //console.log("CatchAddEditBook", e));
  }

  //postFulfillmentService

  function evenOrOdd (num) {
    //for string length take string
    if (num % 2 == 0) {
      //and replace numm with string.length here
      return 'even'
    } else {
      return 'odd'
    }
  }

  var columns = [
    {
      title: <IntlMessages id='fulfil.list.col1' />,
      dataIndex: 'salesOrderID',
      key: 'salesOrderID',
      render: (text, record) => {
        return (
          <strong style={{ color: '#1890ff' }}>
            {record.receiptCode ? record.receiptCode : text}
          </strong>
        )
      }
    },
    {
      title: <IntlMessages id='fulfil.list.col2' />,
      dataIndex: 'outletName',
      key: 'outletName',
      render: (text, record) => {
        return <strong>{text}</strong>
      }
    },
    {
      title: <IntlMessages id='fulfil.list.col3' />,
      dataIndex: 'status',
      key: 'status',
      editable: false,
      render: (text, record) => {
        let status =
          FulfillmentStatus.filter(a => a.id == text).length > 0
            ? FulfillmentStatus.filter(a => a.id == text)[0].value
            : ''
        return <strong>{status}</strong>
      }
    },
    {
      title: <IntlMessages id='fulfil.list.col4' />,
      dataIndex: 'type',
      key: 'type',
      editable: false,
      render: (text, record) => {
        let type =
          FulfillmentTypes.filter(a => a.id == text).length > 0
            ? FulfillmentTypes.filter(a => a.id == text)[0].value
            : ''
        return <strong>{type}</strong>
      }
    },
    {
      title: <IntlMessages id='fulfil.list.col5' />,
      dataIndex: 'customerGroupName',
      key: 'customerGroupName',
      editable: true,
      render: (text, record, key) => {
        let isEvenOrOdd = evenOrOdd(key)
        let firstLetter = record.firstName ? record.firstName.charAt(0) : 'x'
        let secondLetter = record.lastName ? record.lastName.charAt(0) : 'y'
        let lettersName = firstLetter.toUpperCase() + secondLetter.toUpperCase()
        return (
          <div className='gx-module-list-icon'>
            <Row gutter={6}>
              <Col>
                <div className='gx'>
                  <Avatar
                    style={{ fontWeight: 'bold' }}
                    className={`gx-avatar gx-bg-${
                      isEvenOrOdd == 'even' ? 'green' : 'blue'
                    } gx-size-46 mr-10`}
                  >
                    {lettersName}
                  </Avatar>
                </div>
              </Col>

              <Col>
                <div className='gx-module-list-content'>
                  <div className='gx-mail-user-des'>
                    <span className='gx-sender-name'>
                      <p className=''>
                        {`${record.firstName} ${record.lastName}`}
                      </p>
                    </span>

                    <span className='gx-toolbar-separator'>&nbsp;</span>

                    <span className='vd-flag sm:hidden'>
                      {text ? text : 'All Customers'}
                    </span>
                  </div>
                  <div className='gx-message'>
                    <p className='gx-text-truncate'>
                      {record.customerCode ? record.customerCode : '123-ABC'}
                    </p>
                    <p className='gx-text-truncate'>
                      {record.customerEmail ? record.customerEmail : '123-ABC'}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )
      }
    }
  ]

  const FormFields = () => {
    const children = []
    children.push(
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`SearchOutlet`}
          label={<IntlMessages id='fulfil.list.out' />}
        >
          <Select size='large' showSearch optionFilterProp='children'>
            {outletData &&
              outletData.length > 0 &&
              outletData.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.id}>
                    {e.outlet}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`SearchStatus`}
          label={<IntlMessages id='sell.salehistory.col6' />}
        >
          <Select size='large' showSearch optionFilterProp='children'>
            {getFulfillStatus &&
              getFulfillStatus.length > 0 &&
              getFulfillStatus.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.id}>
                    {e.value}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`SearchType`}
          label={<IntlMessages id='fulfil.list.type' />}
        >
          <Select size='large' showSearch optionFilterProp='children'>
            {getFulfillTypes &&
              getFulfillTypes.length > 0 &&
              getFulfillTypes.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.id}>
                    {e.value}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>
    )

    // if (getExpand) {
    if (true) {
      return children
    } else {
      return children.slice(0, 3)
    }
  }

  const SearchFilters = () => {
    return (
      <Card className='Filters-wrapper Filters-border-with-tabs'>
        <Form
          form={form}
          name='SearchForm'
          className='ant-advanced-search-form Filters-Form'
          layout='horizontal'
          initialValues={{
            SearchOutlet: 0,
            SearchStatus: 0,
            SearchType: 0
          }}
          onFinish={onSearchFinish}
          onFinishFailed={onSearchFinishFailed}
        >
          <Row>{FormFields()}</Row>

          <div className='display-margin-unset'>
            <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                <Button
                  type='primary'
                  className='dk-btn-clear-field'
                  onClick={() => {
                    form.resetFields()
                  }}
                >
                  <IntlMessages id='sell.salehistory.clear' />
                </Button>

                <Button className='' type='primary' htmlType='submit'>
                  <IntlMessages id='sell.salehistory.search' />
                </Button>
              </Col>
            </Row>
          </div>
        </Form>
      </Card>
    )
  }

  const onSearchFinish = values => {
    try {
      setIsLoading(true)
      var body = getPagination
      body.OutletID = form.getFieldValue('SearchOutlet')
        ? form.getFieldValue('SearchOutlet')
        : 0
      body.StatusID = form.getFieldValue('SearchStatus')
        ? form.getFieldValue('SearchStatus')
        : 0
      body.TypeID = form.getFieldValue('SearchType')
        ? form.getFieldValue('SearchType')
        : 0
      body.IsPackOrder = getIsPackOrder
      getListingService(body)
    } catch (e) {
      setTabLoader(false)
      message.error('Problem, check connection...')
    }
  }

  const onSearchFinishFailed = errorInfo => {
    setIsLoading(false)
    message.error('Connection lost...')
  }

  function onTabChange (key) {
    try {
      if (key == 1) {
        setIsPackOrder(false)
        setIsLoading(true)
        setCurrentTab(key)
        let statuses = FulfillmentStatus
        let types = FulfillmentTypes
        setFulfillStatus(statuses)
        setFulfillTypes(types)
        form.setFieldsValue({
          SearchOutlet: 0,
          SearchStatus: 0,
          SearchType: 0
        })
        var body = getPagination
        body.OutletID = form.getFieldValue('SearchOutlet')
          ? form.getFieldValue('SearchOutlet')
          : 0
        body.StatusID = form.getFieldValue('SearchStatus')
          ? form.getFieldValue('SearchStatus')
          : 0
        body.TypeID = form.getFieldValue('SearchType')
          ? form.getFieldValue('SearchType')
          : 0
        body.IsPackOrder = false
        getListingService(body)
      } else if (key == 2) {
        setIsPackOrder(true)
        setIsLoading(true)
        setCurrentTab(key)
        let statuses = FulfillmentStatus.filter(a => a.id != 3)
        let types = FulfillmentTypes
        setFulfillStatus(statuses)
        setFulfillTypes(types)
        form.setFieldsValue({
          SearchOutlet: 0,
          SearchStatus: 0,
          SearchType: 0
        })
        var body = getPagination
        body.OutletID = form.getFieldValue('SearchOutlet')
          ? form.getFieldValue('SearchOutlet')
          : 0
        body.StatusID = form.getFieldValue('SearchStatus')
          ? form.getFieldValue('SearchStatus')
          : 0
        body.TypeID = form.getFieldValue('SearchType')
          ? form.getFieldValue('SearchType')
          : 0
        body.IsPackOrder = true
        getListingService(body)
      } else if (key == 3) {
        setIsPackOrder(false)
        setIsLoading(true)
        setCurrentTab(key)
        let statuses = FulfillmentStatus.filter(a => a.id == 3)
        let types = FulfillmentTypes.filter(a => a.id == 5)
        setFulfillStatus(statuses)
        setFulfillTypes(types)
        form.setFieldsValue({
          SearchOutlet: 0,
          SearchStatus: 3,
          SearchType: 5
        })
        var body = getPagination
        body.OutletID = form.getFieldValue('SearchOutlet')
          ? form.getFieldValue('SearchOutlet')
          : 0
        body.StatusID = form.getFieldValue('SearchStatus')
          ? form.getFieldValue('SearchStatus')
          : 0
        body.TypeID = form.getFieldValue('SearchType')
          ? form.getFieldValue('SearchType')
          : 0
        body.IsPackOrder = false
        getListingService(body)
      } else if (key == 4) {
        setIsPackOrder(false)
        setIsLoading(true)
        setCurrentTab(key)
        let statuses = FulfillmentStatus.filter(a => a.id == 3)
        let types = FulfillmentTypes.filter(a => a.id == 4)
        setFulfillStatus(statuses)
        setFulfillTypes(types)
        form.setFieldsValue({
          SearchOutlet: 0,
          SearchStatus: 3,
          SearchType: 4
        })
        var body = getPagination
        body.OutletID = form.getFieldValue('SearchOutlet')
          ? form.getFieldValue('SearchOutlet')
          : 0
        body.StatusID = form.getFieldValue('SearchStatus')
          ? form.getFieldValue('SearchStatus')
          : 0
        body.TypeID = form.getFieldValue('SearchType')
          ? form.getFieldValue('SearchType')
          : 0
        body.IsPackOrder = false
        getListingService(body)
      }
    } catch (ex) {
      setIsLoading(false)
      message.warn('FAILED, refresh & check connection')
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setIsLoading(true)
    var body = getPagination
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    body.OutletID = form.getFieldValue('SearchOutlet')
      ? form.getFieldValue('SearchOutlet')
      : 0
    body.StatusID = form.getFieldValue('SearchStatus')
      ? form.getFieldValue('SearchStatus')
      : 0
    body.TypeID = form.getFieldValue('SearchType')
      ? form.getFieldValue('SearchType')
      : 0
    body.IsPackOrder = getIsPackOrder
    getListingService(body)
  }

  const ExpandedRowRenderViewAll = props => {
    function showVoidConfirm (key) {
      setKey(key)
      setVisible(true)
    }

    return (
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getDetailLoading}
        size='large'
      >
        <div className='sub-table-box'>
          <Row className='sub-table-box-header'>
            <Col
              xl={18}
              lg={18}
              md={24}
              sm={24}
              xs={24}
              className='add-row-divider'
            >
              <Row>
                <Col span={8}>
                  <h3>
                    <IntlMessages id='fulfil.list.item' />
                  </h3>
                </Col>

                <Col span={8}>
                  <h3>
                    <IntlMessages id='fulfil.list.itemnote' />
                  </h3>
                </Col>

                <Col span={8}>
                  <h3>
                    <IntlMessages id='fulfil.list.itemquanty' />
                  </h3>
                </Col>
              </Row>

              <Divider style={{ backgroundColor: '#e5e5e5' }} />

              {getDetailData &&
                getDetailData.items &&
                getDetailData.items.length > 0 &&
                getDetailData.items.map((e, key) => {
                  return (
                    <Row style={{ marginLeft: 10 }}>
                      <Col span={8}>
                        <h4 className='mb-0'>{e.itemName}</h4>
                      </Col>

                      <Col span={8}>
                        <h4 className='mb-0'>{e.itemNote}</h4>
                      </Col>

                      <Col style={{ textAlign: 'center' }} span={8}>
                        <h4 className='mb-0'>
                          {`${e.quantity} `}
                          <IntlMessages id='fulfil.list.items' />
                        </h4>
                      </Col>
                      <Divider />
                    </Row>
                  )
                })}

              <Row>
                <Col span={24}>
                  <h4 className='mb-0'>
                    {' '}
                    <IntlMessages id='fulfil.list.salenote' />:{' '}
                  </h4>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <p>
                    {getDetailData && getDetailData.saleNote
                      ? getDetailData.saleNote
                      : ''}
                  </p>
                </Col>
              </Row>
            </Col>

            <Col xl={6} lg={6} md={24} sm={24} xs={24}>
              <div className='dk-expand-btn-mobile button-box mt-3'>
                {getDetailData && getDetailData.status && getDetailData.type && (
                  <>
                    {getDetailData.status != 3 && (
                      <>
                        <Button
                          className=''
                          type='primary'
                          onClick={() => showVoidConfirm('packed')}
                        >
                          <Space size='small'>
                            <ShoppingOutlined />
                            {<IntlMessages id='fulfil.list.markpack' />}
                          </Space>
                        </Button>
                      </>
                    )}

                    {getDetailData.type == 4 && (
                      <Button
                        className='mt-3'
                        type='primary'
                        onClick={() => showVoidConfirm('shipped')}
                      >
                        <Space size='small'>
                          <CheckOutlined />
                          {<IntlMessages id='fulfil.list.markship' />}
                        </Space>
                      </Button>
                    )}

                    <Button
                      className='mt-3'
                      type='primary'
                      onClick={() =>
                        history.push(
                          `/dashboard/sell/salehistory/sale/${getDetailData.salesOrderID}/1`
                        )
                      }
                    >
                      <Space size='small'>
                        <EyeOutlined />
                        {<IntlMessages id='fulfil.list.viewsale' />}
                      </Space>
                    </Button>

                    {getDetailData.type == 5 && (
                      <Button
                        className='mt-3'
                        type='primary'
                        onClick={() => showVoidConfirm('picked')}
                      >
                        <Space size='small'>
                          <CheckOutlined />
                          {<IntlMessages id='fulfil.list.markpickip' />}
                        </Space>
                      </Button>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Spin>
    )
  }

  function onClickMark () {
    setVisible(false)
    setIsLoading(true)
    if (key == 'packed') {
      var body = {
        OrderID: getDetailData.salesOrderID ? getDetailData.salesOrderID : '',
        Status: 3,
        Type: getDetailData.type ? getDetailData.type : 0
      }
      postFulfillment(body)
    } else if (key == 'picked') {
      var body = {
        OrderID: getDetailData.salesOrderID ? getDetailData.salesOrderID : '',
        Status: getDetailData.status ? getDetailData.status : 0,
        Type: 10
      }
      postFulfillment(body)
    } else if (key == 'shipped') {
      var body = {
        OrderID: getDetailData.salesOrderID ? getDetailData.salesOrderID : '',
        Status: getDetailData.status ? getDetailData.status : 0,
        Type: 9
      }
      postFulfillment(body)
    }
  }

  const DialogModal = props => {
    const [getModalLoading, setModalLoading] = useState(false)

    return (
      <Modal
        className='fulfillmentPacked-modal'
        title={
          <strong>
            {key == 'packed' && <IntlMessages id='fulfil.list.packtitle' />}
            {key == 'picked' && <IntlMessages id='fulfil.list.picktitle' />}
            {key == 'shipped' && <IntlMessages id='fulfil.list.shiptitle' />}
          </strong>
        }
        centered
        visible={key && visible}
        width={600}
        footer={
          <>
            <Button
              className='dk-btn-cancel'
              type='primary'
              onClick={() => {
                setVisible(false)
                setKey('')
              }}
            >
              {key == 'packed' && (
                <IntlMessages id='fulfil.list.dontmarkpack' />
              )}
              {key == 'picked' && (
                <IntlMessages id='fulfil.list.dontmarkpick' />
              )}
              {key == 'shipped' && (
                <IntlMessages id='fulfil.list.dontmarkship' />
              )}
            </Button>

            <Button
              className='custom-btn-add-new'
              type='primary'
              onClick={() => onClickMark()}
            >
              {key == 'packed' && <IntlMessages id='fulfil.list.markpack' />}
              {key == 'picked' && <IntlMessages id='fulfil.list.markpickip' />}
              {key == 'shipped' && <IntlMessages id='fulfil.list.markship' />}
            </Button>
          </>
        }
        onCancel={() => setVisible(false)}
      >
        <Spin
          tip={<IntlMessages id='sell.cashlisting.cashloading' />}
          spinning={getModalLoading}
          size='large'
        >
          {key && (
            <>
              <Row>
                <Col span={24}>
                  <p>
                    {key == 'packed' && (
                      <IntlMessages id='fulfil.list.packdetail' />
                    )}
                    {key == 'picked' && (
                      <IntlMessages id='fulfil.list.pickdetail' />
                    )}
                    {key == 'shipped' && (
                      <IntlMessages id='fulfil.list.shipdetail' />
                    )}
                  </p>
                </Col>
              </Row>
              <Row style={{ marginTop: 22 }} gutter={12} justify='end'>
                <Col></Col>
                <Col></Col>
              </Row>
            </>
          )}
        </Spin>
      </Modal>
    )
  }

  return (
    <div className='Content-wrapper Fulfillments-pg SalesHistory-pg'>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getIsLoading}
        size='large'
      >
        <DialogModal />

        <Row>
          <Col span={24}>
            <h1 className=''>
              <IntlMessages id='fulfil.list.title' />
            </h1>
          </Col>
        </Row>

        <Card className='gx-card' title=''>
          <Collapse>
            <Panel
              className='custom-promolist-help'
              showArrow={false}
              header={
                <span>
                  <IntlMessages id='fulfil.list.needhelp' />
                </span>
              }
            >
              <Row>
                <div className='billing-main'>
                  <Col span={24}>
                    <h3>
                      <IntlMessages id='fulfil.list.needhelp1' />
                    </h3>
                    <br />
                    <h3>
                      <IntlMessages id='fulfil.list.needhelp3' />
                    </h3>
                    <br />
                    <h3>
                      <IntlMessages id='fulfil.list.needhelp4' />
                    </h3>
                    <br />
                    <h3>
                      <IntlMessages id='fulfil.list.needhelp5' />
                    </h3>
                    <br />
                    <h2>
                      <strong>
                        <IntlMessages id='fulfil.list.needhelp6' />
                      </strong>
                    </h2>
                    <br />
                    <h3>
                      <Badge
                        status='processing'
                        text={<IntlMessages id='fulfil.list.needhelp7' />}
                      />
                    </h3>
                    <h3>
                      <Badge
                        status='processing'
                        text={<IntlMessages id='fulfil.list.needhelp8' />}
                      />
                    </h3>
                    <h3>
                      <Badge
                        status='processing'
                        text={<IntlMessages id='fulfil.list.needhelp9' />}
                      />
                    </h3>
                    <h3>
                      <Badge
                        status='processing'
                        text={<IntlMessages id='fulfil.list.needhelp10' />}
                      />
                    </h3>
                  </Col>
                </div>
              </Row>
            </Panel>
          </Collapse>
        </Card>

        <Tabs defaultActiveKey='1' size='large' onChange={onTabChange}>
          <TabPane tab={<IntlMessages id='fulfil.list.tab1' />} key='1'>
            <SearchFilters />

            <div className='tab-body-parent'>
              <Card title=''>
                {getTabLoader ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  <Table
                    className='gx-table-responsive custom-product-table font-weight-normal MinWidth-auto'
                    columns={columns}
                    dataSource={getTabData}
                    expandable={{
                      expandedRowRender: (record, index) => (
                        <ExpandedRowRenderViewAll data={record} obj={index} />
                      ),
                      onExpand: (expanded, record) => {
                        setRowKey(record.key)
                        setDetailLoading(true)
                        let body = {
                          OrderID: record.key
                        }
                        getDetailService(body)
                      }
                      // rowExpandable: (record) =>
                      //   record.VariantName !== "Not Expandable",
                    }}
                    rowKey={record => record.key}
                    expandedRowKeys={[rowKey]}
                    pagination={getPagination}
                    onChange={handleTableChange}
                    expandRowByClick
                  />
                )}
              </Card>
            </div>
          </TabPane>

          <TabPane
            style={{ fontWeight: 'bold' }}
            tab={<IntlMessages id='fulfil.list.tab2' />}
            key='2'
          >
            <SearchFilters />
            <div className='tab-body-parent'>
              <Card title=''>
                {getTabLoader ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  <Table
                    className='gx-table-responsive custom-product-table font-weight-normal MinWidth-auto'
                    columns={columns}
                    dataSource={getTabData}
                    expandable={{
                      expandedRowRender: (record, index) => (
                        <ExpandedRowRenderViewAll data={record} obj={index} />
                      ),
                      onExpand: (expanded, record) => {
                        setRowKey(record.key)
                        setDetailLoading(true)
                        let body = {
                          OrderID: record.key
                        }
                        getDetailService(body)
                      }
                      // rowExpandable: (record) =>
                      //   record.VariantName !== "Not Expandable",
                    }}
                    rowKey={record => record.key}
                    expandedRowKeys={[rowKey]}
                    pagination={getPagination}
                    onChange={handleTableChange}
                    expandRowByClick
                  />
                )}
              </Card>
            </div>
          </TabPane>

          <TabPane
            style={{ fontWeight: 'bold' }}
            tab={<IntlMessages id='fulfil.list.tab3' />}
            key='3'
          >
            <SearchFilters />
            <div className='tab-body-parent'>
              <Card title=''>
                {getTabLoader ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  <Table
                    className='gx-table-responsive font-weight-normal MinWidth-auto'
                    columns={columns}
                    dataSource={getTabData}
                    expandable={{
                      expandedRowRender: (record, index) => (
                        <ExpandedRowRenderViewAll data={record} obj={index} />
                      ),
                      onExpand: (expanded, record) => {
                        setRowKey(record.key)
                        setDetailLoading(true)
                        let body = {
                          OrderID: record.key
                        }
                        getDetailService(body)
                      }
                      // rowExpandable: (record) =>
                      //   record.VariantName !== "Not Expandable",
                    }}
                    rowKey={record => record.key}
                    expandedRowKeys={[rowKey]}
                    pagination={getPagination}
                    onChange={handleTableChange}
                    expandRowByClick
                  />
                )}
              </Card>
            </div>
          </TabPane>

          <TabPane
            style={{ fontWeight: 'bold' }}
            tab={<IntlMessages id='fulfil.list.tab4' />}
            key='4'
          >
            <SearchFilters />
            <div className='tab-body-parent'>
              <Card title=''>
                {getTabLoader ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  <Table
                    className='gx-table-responsive font-weight-normal MinWidth-auto'
                    columns={columns}
                    dataSource={getTabData}
                    expandable={{
                      expandedRowRender: (record, index) => (
                        <ExpandedRowRenderViewAll data={record} obj={index} />
                      ),
                      onExpand: (expanded, record) => {
                        setRowKey(record.key)
                        setDetailLoading(true)
                        let body = {
                          OrderID: record.key
                        }
                        getDetailService(body)
                      }
                      // rowExpandable: (record) =>
                      //   record.VariantName !== "Not Expandable",
                    }}
                    rowKey={record => record.key}
                    expandedRowKeys={[rowKey]}
                    pagination={getPagination}
                    onChange={handleTableChange}
                    expandRowByClick
                  />
                )}
              </Card>
            </div>
          </TabPane>
        </Tabs>
      </Spin>
    </div>
  )
}
export default FulfillmentList
